import { render, staticRenderFns } from "./ActivateCompany.vue?vue&type=template&id=3ec22a8f"
import script from "./ActivateCompany.vue?vue&type=script&lang=js"
export * from "./ActivateCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports